import { classes } from 'html-classes';
import { forwardRef } from 'react';

import type { OverlayProps } from './interfaces';
import styles from './MobileHeaderCard.module.scss';

const Overlay = forwardRef<HTMLDivElement, OverlayProps>(
  ({ className, isOpen, children, onTransitionEnd }, ref) => (
    <div
      className={classes([styles.overlay, className, isOpen && 'opened'])}
      onTransitionEnd={onTransitionEnd}
      ref={ref}
    >
      {children}
    </div>
  ),
);
Overlay.displayName = 'HeaderDropdownOverlay';

export default Overlay;
